import { useEffect, useMemo, useRef } from 'react';

import { useGenerateExternalIdentityVerificationParamsMutation } from '@ocx/graphql';
import { logInDev } from '@ocx/utils';

export const useGenerateExternalIdentityVerificationParams = () => {
  const isTriggeredRef = useRef(false);
  const [mutation, { data, loading, error }] = useGenerateExternalIdentityVerificationParamsMutation();
  useEffect(() => {
    if (isTriggeredRef.current) return;
    isTriggeredRef.current = true;
    mutation().catch(logInDev);
  }, [mutation]);

  return useMemo(() => {
    return {
      loading,
      error,
      data: data?.result || null,
    };
  }, [data?.result, error, loading]);
};
